import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Ask AI',
  content: `
## Overview

Pliable's AI Analyst allows data exploration by enabling natural language conversations with your data. This feature allows stakeholders to be fully self-service on top of governed entities and metrics, eliminating the need for analysts to serve ad-hoc requests.

## Key Features

- **Natural Language Queries**: Ask questions in plain English
- **Context-Aware Conversations**: Build on previous questions in a dialogue format
- **Governed Semantic Layer**: Ensures consistent metrics and definitions
- **Visualization Generation**: Automatically creates charts and tables
- **Persistent Analysis**: Retains all generated artifacts from conversations

## How It Works

1. **Ask your question**: Type a natural language question in the "Ask AI" field
2. **AI understands**: The AI interprets your request using Pliable's semantic layer
3. **Analysis generated**: The system creates the appropriate visualization
4. **Refine or expand**: Continue the conversation to modify or enhance the analysis

### Example Conversation

\`\`\`
User: "Show me last year's total revenue"
AI: Generates single-value display of total sales for last year

User: "Can you show that broken down by product category and sales channel? Make it a bar chart"
AI: Creates a bar chart with dimensions: Product Category and Sales Channel
\`\`\`

## Benefits

- **Eliminate ad-hoc requests**: Stakeholders become self-sufficient
- **Focus on strategic work**: Analysts tackle larger problems
- **Cost reduction**: Companies may not need dedicated analysts
- **Faster insights**: Natural language exploration accelerates discovery

## Getting Started

1. Access **"Ask AI"** from the Insights section
2. Type your first question about your data
3. Review the generated visualization
4. Refine your question using natural language
5. Save the final visualization to dashboards

## Advanced Features

- **Context retention**: The AI remembers previous questions in your session
- **Multi-step analysis**: Build complex analyses through conversation
- **Governance controls**: All queries use approved metrics and definitions
- **Export capabilities**: Share results directly from the conversation
`,
};

export default doc;
